import routerOptions0 from "/builds/proverky/proverky.net/frontend/node_modules/.pnpm/nuxt@3.12.3_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.2.1_db0@0.3.2_esl_eaa8de399f7c8293c61483be9e38c7a2/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}